import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from './auth';

// API client para la administración cross-tenant de client_tabs
// (uso del superTenant STIL / userType=liftlogic).

const authHeaders = () => ({
  Authorization: getAccessTokenApi(),
  'Content-Type': 'application/json',
});

export const listClientTabsAdmin = async (tenantId, userType) => {
  const res = await axios.get(
    `${API_PATH}/liftlogic/client-tabs?tenantId=${tenantId}&userType=${userType}`,
    { headers: authHeaders() }
  );
  return res.data;
};

export const createClientTabAdmin = async (payload) => {
  const res = await axios.post(`${API_PATH}/liftlogic/client-tabs`, payload, {
    headers: authHeaders(),
  });
  return res.data;
};

export const updateClientTabAdmin = async (id, updates) => {
  const res = await axios.put(`${API_PATH}/liftlogic/client-tabs/${id}`, updates, {
    headers: authHeaders(),
  });
  return res.data;
};

export const deleteClientTabAdmin = async (id) => {
  const res = await axios.delete(`${API_PATH}/liftlogic/client-tabs/${id}`, {
    headers: authHeaders(),
  });
  return res.data;
};

export const reorderClientTabsAdmin = async (tenantId, userType, updates) => {
  const res = await axios.patch(
    `${API_PATH}/liftlogic/client-tabs/reorder`,
    { tenantId, userType, updates },
    { headers: authHeaders() }
  );
  return res.data;
};
